/*
 * SPDX-FileCopyrightText: 2024 CERN.
 * SPDX-License-Identifier: MIT
 */

import { http } from "react-invenio-forms";

export class GrantAccessApi {
  constructor(record) {
    this.endpoint = record.links.access_grants;
    this.ownership = record.links.ownership;
  }

  createGrants = async (entities, permission, message, notify) => {
    if (permission === "owner" && Object.keys(entities).length > 1) {
      alert("Ownership can be transferred to only one user.")
      return
    }
    const grants = [];
    for (const [entityId, entity] of Object.entries(entities)) {
      const grant = {
        subject: {
          type: entity.type,
          id: entityId,
        },
        permission: permission,
      };

      if (notify) {
        grant.notify = notify;
      }

      if (message) {
        grant.message = message;
      }

      grants.push(grant);
    }

    const payload = { grants: grants };

    if (permission === "owner") {
      await http.post(this.ownership, payload);
    } else {
      await http.post(this.endpoint, payload);
    }
  };
}
